



















































import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public active = 0;
  public questionList = [
    {
      title: "区服客服的QQ和微信是多少，要怎么联系他们",
      list: [
        "会有区服客服联系方式的地方：",
        "① 一般在区服登录页面的公告上",
        "② 区服登录页面的公告内的区服官网内",
        "③ 游戏内按钮或者npc",
        "④ 同时留意下游戏内聊天框的系统公告",
        "⑤ 游戏攻略内",
      ],
    },
    {
      title: "云游戏卡顿怎么办",
      list: [
        "云游戏是远程视频流传输画面。您的网络状态决定延迟情况。相当于您观看直播画面。请先点击查看悬浮窗的延迟数值。如果您的延迟高于100ms，建议您切换网络或者退出后尝试再启动。",
      ],
    },
    {
      title: "为什么云游戏这么费流量",
      list: [
        "云游戏是远程视频流传输画面，主要是方便玩家“挂机”使用，正常挂机退出后不会占用流量。如果需要使用该功能正常游戏，则建议在wifi状态下使用。",
      ],
    },
  ];

  public activeChange(index) {
    this.active = index;
  }
}
